/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast. Keeping your custom
* Javascript in this file will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(function() {
  // Add custom code below this line

  document.addEventListener('DOMContentLoaded', function () {

    document.addEventListener('click', function (event) {
      var checkoutButton = event.target.closest('button[name="checkout"]');

      if (!checkoutButton) return;

      var cartForm = checkoutButton.closest('form') ||
        document.querySelector('form[action*="/cart"]');

      if (!cartForm) return;

      var selectedParcelyMethod =
        document.querySelector('input.parcelyRadio:checked');

      if (!selectedParcelyMethod) {
        console.log('[Checkout Fix] No Parcely shipping method selected');
        return;
      }

      var methodContainer =
        selectedParcelyMethod.closest('.parcely_app_shipping_method');

      var methodName = methodContainer
        ? methodContainer.innerText.trim()
        : '';

      // Courier: English, Finnish, Estonian, German
      if (
        methodName.includes('Courier') ||
        methodName.includes('Kuriiri') ||
        methodName.includes('Kuller') ||
        methodName.includes('Kurier')
      ) {
        runCheckoutFallback(cartForm, checkoutButton);
        return;
      }

      // Pickup point / parcel locker: English, Finnish, Estonian, German
      if (
        methodName.includes('Delivery to locker or pick-up point') ||
        methodName.includes('Toimitus pakettiautomaattiin tai noutopisteeseen') ||
        methodName.includes('Pakiautomaadid') ||
        methodName.includes('Lieferung an einen Paketautomaten oder Abholpunkt')
      ) {
        fetch('/cart.js')
          .then(function(response) {
            return response.json();
          })
          .then(function(cart) {
            if (cart.attributes && cart.attributes.Location_ID) {
              runCheckoutFallback(cartForm, checkoutButton);
            } else {
              console.log('[Checkout Fix] No pickup point selected');
            }
          })
          .catch(function(error) {
            console.error('[Checkout Fix] Cart validation failed', error);
          });
      }
    });

    function runCheckoutFallback(cartForm, checkoutButton) {
      setTimeout(function () {
        if (
          window.location.pathname === '/cart' ||
          window.location.pathname.endsWith('/cart')
        ) {
          console.log('[Checkout Fix] Running fallback submit');
          cartForm.requestSubmit(checkoutButton);
        }
      }, 500);
    }

  });

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();